import { gql } from "@apollo/client";
import { GaragePropertyPaginator } from "@App/apis/graphql/perimeterSearch/responses/garagePropertyPaginator";

export interface GetGaragePropertiesResponse {
  garageProperties: GaragePropertyPaginator;
}

export const GET_GARAGE_PROPERTIES = gql`
    query getGarageProperties($id: [UUID], $garages: [ID], $services:[ID], $networks: [ID], $showInFilter: Boolean, $showInList: Boolean, $showInDetailView: Boolean, $internalIdentifier: [String]) {
        garageProperties(
            id: $id
            garages: $garages,
            networks: $networks,
            services: $services,
            show_in_filter: $showInFilter,
            show_in_list: $showInList,
            show_in_detail_view: $showInDetailView,
            internal_identifier: $internalIdentifier) {
            data {
                id
                name
                description
                detail_view_text
                show_in_detail_view
                filter_text
                show_in_filter
                list_text
                show_in_list
                internal_identifier
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
            }
        }
    }
`;
